<template>
    <div>
        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/FinancialServices/NetworkIDTs">
              Financial Services
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/FinancialServices/Assets">Computer Assets</b-breadcrumb-item>
            <b-breadcrumb-item active>Edit</b-breadcrumb-item>
        </b-breadcrumb>

        <form @submit.prevent="onSubmit()">
            <div class="card">
                <div class="bg-dark card-header text-white">Edit Computer Asset</div>
                <div v-if="computerAsset !== null" class="card-body">
                    <div>
                        <fieldset v-if="computerAsset.organizationCode == null || computerAsset.custodianPersonName == null || computerAsset.organizationId == null || computerAsset.custodianPersonId == null || (computerAsset.organizationIsActive != null && !computerAsset.organizationIsActive) || (computerAsset.custodianIsActive != null && !computerAsset.custodianIsActive)" class="border p-3 mr-2">
                            <legend class="w-auto h5">
                                <i class="fa fa-exclamation-circle" style="color: red !important;display:inline;padding-right:5px;"></i>
                                <span>Sync Data Issues</span>
                            </legend>
                            <b-row v-if="computerAsset.custodianPersonName == null || computerAsset.custodianPersonId == null || (computerAsset.custodianIsActive != null && !computerAsset.custodianIsActive)">
                                <b-col v-if="computerAsset.custodianPersonName == null || computerAsset.custodianPersonId == null">
                                    <div class="col-md-3">
                                        <label>Custodian Name</label>
                                        <div class="pl-4">{{ computerAsset.custodianPersonName == null ? "-" : computerAsset.custodianPersonName }}</div>
                                    </div>
                                    <div v-if="computerAsset.custodianPersonId == null" class="col-md-3">
                                        <label>Custodian BIMS Record Status</label>
                                        <div class="pl-4">Missing</div>
                                    </div>
                                </b-col>
                                <b-col v-if="computerAsset.custodianIsActive != null && !computerAsset.custodianIsActive">
                                    <div class="col-md-3">
                                        <label>Custodian Status</label>
                                        <div class="pl-4">Inactive</div>
                                    </div>
                                </b-col>
                            </b-row>
                            <b-row v-if="computerAsset.organizationCode == null || computerAsset.organizationId == null || (computerAsset.organizationIsActive != null && !computerAsset.organizationIsActive)">
                                <b-col v-if="computerAsset.organizationCode == null || computerAsset.organizationId == null">
                                    <div class="col-md-3">
                                        <label>Organization Code</label>
                                        <div class="pl-4">{{ computerAsset.organizationCode == null ? "-" : computerAsset.organizationCode }}</div>
                                    </div>
                                    <div v-if="computerAsset.organizationId == null" class="col-md-3">
                                        <label>Organization BIMS Record Status</label>
                                        <div class="pl-4">Missing</div>
                                    </div>
                                </b-col>
                                <b-col v-if="computerAsset.organizationIsActive != null && !computerAsset.organizationIsActive">
                                    <div class="col-md-3">
                                        <label>Organization Status</label>
                                        <div class="pl-4">Inactive</div>
                                    </div>
                                </b-col>
                            </b-row>
                        </fieldset>
                         <br>
                    </div>

                    <div>
                        <fieldset class="border p-3 mr-2">
                            <legend class="w-auto h5">
                                <span>Asset Details</span>
                            </legend>
                            
                            <div class="row">
                                <div class="col-lg-3 col-md-4">
                                    <label for="assetNumber">Asset Number</label>
                                    <div class="text-center">{{ computerAsset.assetNumber }}</div>
                                </div>
                            </div>
                            
                            <div class="row">
                                <div class="col-lg-3 col-md-4 form-group">
                                    <label for="manufacturer">Manufacturer</label>
                                    <input class="form-control"
                                            v-model="computerAsset.manufacturer"/>
                                </div>
                                <div class="col-lg-3 col-md-4 form-group">
                                    <label for="modelNumber">Model Number</label>
                                    <input class="form-control"
                                            v-model="computerAsset.modelNumber"/>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-lg-3 col-md-4 form-group">
                                    <label for="serialNumber">Serial Number</label>
                                    <input class="form-control"
                                            v-model="computerAsset.serialNumber"/>
                                </div>
                                <div class="col form-group">
                                    <label for="description">Description</label>
                                    <input class="form-control"
                                            v-model="computerAsset.description"/>
                                </div>
                            </div>
                        </fieldset>
                         <br>
                    </div>

                    <div>
                        <fieldset class="border p-3 mr-2">
                            <legend class="w-auto h5">
                                <span>Purchase Details</span>
                            </legend>

                            <div class="row">
                                <div class="col form-group">
                                    <label for="vendor">Vendor</label>
                                    <input class="form-control"
                                            v-model="computerAsset.vendor"/>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-md-2 form-group">
                                    <label for="purchaseAmount">Purchase Amount</label>
                                    <input class="form-control"
                                            v-model="computerAsset.purchaseAmount"/>
                                </div>
                                <div class="col-md-3 form-group">
                                    <label for="purchaseDate">Purchase Date</label>
                                    <b-input-group class="mb-3">
                                    <b-form-input
                                        v-model="tempPurchaseDate"
                                        type="text"
                                        placeholder="MM/DD/YYYY"
                                        autocomplete="off"
                                        @change="updatePurchaseDateFromInput()"
                                    ></b-form-input>
                                    <b-input-group-append>
                                        <b-form-datepicker
                                        id="purchaseDate"
                                        v-model="computerAsset.purchaseDate"
                                        button-only
                                        right
                                        locale="en-US"
                                        aria-controls="purchaseDate"
                                        @context="updatePurchaseDateFromButton()"
                                        ></b-form-datepicker>
                                    </b-input-group-append>
                                    </b-input-group>
                                </div>
                            </div>
                        </fieldset>
                         <br>
                    </div>

                    <div>
                        <fieldset class="border mb-3 p-3 mr-2">
                            <legend class="w-auto h5">
                                <span>Assignment Details</span>
                            </legend>
                            <div class="row">
                                <div class="col-md-4 form-group">
                                    <label for="custodianPersonId">Custodian</label>
                                    <select class="form-control" v-model="computerAsset.custodianPersonId" :key="custodians">
                                        <option :value="null" disabled>--Select Person--</option>
                                        <option :key="custodian.id" :value="custodian.id" v-for="custodian in custodians">{{custodian.name}}</option>
                                    </select>
                                </div>
                                <div class="col-lg-2 col-md-3 form-group">
                                    <label for="organization">Organization</label>
                                    <div class="text-center">{{ computerAsset.organizationCode == null ? "-" : computerAsset.organizationCode }}</div>
                                </div>
                            </div>
                        </fieldset>
                         <br>
                    </div>
                </div>
                <div class="card-footer d-print-none text-right">
                    <button :disabled="isSubmitting" class="btn btn-primary" type="submit">Save</button>
                    <RouterLink :to="{name:'ComputerAssets'}" class="btn btn-danger">Back</RouterLink>
                </div>
            </div>
        </form>

    </div>
</template>

<script>
    import {ToastType} from "@/services/models/shared/ToastType";
    import ComputersService from "@/services/ComputersService";
    import PersonService from "@/services/PersonService";

    export default {
        props: {
            id: {
              type: String,
              required: true
            }
        },
        data() {
            return {
                custodians: [],
                isSubmitting: false,
                isValidating: false,
                computerAsset: null,
                tempPurchaseDate: null
            }
        },
        methods: {
            /**
             * @description Updates a computer asset and redirects if successful
             */
            onSubmit() {
                const vm = this;
                vm.isValidating = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                vm.isSubmitting = true;

                ComputersService.updateComputerAsset(this.id, {
                    serialNumber: this.computerAsset.serialNumber,
                    manufacturer: this.computerAsset.manufacturer,
                    modelNumber: this.computerAsset.modelNumber,
                    description: this.computerAsset.description,
                    vendor: this.computerAsset.vendor,
                    custodianPersonId: this.computerAsset.custodianPersonId,
                    purchaseAmount: this.computerAsset.purchaseAmount,
                    purchaseDate: this.computerAsset.purchaseDate,
                    lastModifiedByPersonId: this.$store.getters.user.id
                })
                    .then(response => {
                      vm.alert(ToastType.Success, "The computer asset was successfully updated");
                      vm.$router.replace({name:'ComputerAssets'})
                    })
                    .catch((error) => {
                      vm.alert(ToastType.Danger, error.response.data)
                    })
                    .finally(() => {
                      vm.isValidating = false;
                      vm.isSubmitting = false;
                    })
            },

            loadComputerAsset () {
              const vm = this;

              ComputersService.getComputerAsset(this.id)
                  .then(response => {
                      vm.computerAsset = response;
                      vm.tempPurchaseDate = this.$moment(response.purchaseDate).format("MM/DD/YYYY");
                  })
                  .catch(error => {
                      vm.alert(ToastType.Danger, error.response.data)
                  })
            },

            loadCustodians () {
              const vm = this;

              PersonService.getPeopleList({
                page: 1,
                pageSize: 10,
                name: null,
                uin: null,
                organizationCode: null,
                onlyShowActive: true,
                onlyShowTTI: true,
                onlyShowMissingAddress: false,
                returnAll: true
              })
                  .then(response => {
                      this.custodians = response.data;
                  })
                  .catch(error => {
                      vm.alert(ToastType.Danger, error.response.data)
                  })
            },

            updatePurchaseDateFromInput () {
                if (this.tempPurchaseDate !== null) {
                  this.computerAsset.purchaseDate = this.$moment(this.tempPurchaseDate, "MM/DD/YYYY").toDate()
                }
            },

            updatePurchaseDateFromButton () {
                if (this.computerAsset.purchaseDate !== null) {
                  this.tempPurchaseDate = this.$moment(this.computerAsset.purchaseDate).format("MM/DD/YYYY")
                }
            }
        },
        created () {
          this.loadCustodians()
        },
        mounted () {
          this.loadComputerAsset(this.id);
        }
    }
</script>

<style scoped>
label {
    font-weight: bold;
}
</style>